import API from '../config/api';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';

import {
  Container,  
  Row,
  Col,
  Card,
  Button,
  Badge
} from 'react-bootstrap';

import { useParams, useNavigate } from 'react-router-dom';

import CustomNavbar from '../components/CustomNavbar';
import QuickViewModal from '../components/QuickViewModal';
import ProductMiniGrid from '../components/product/ProductMiniGrid';
import ProductReviews from '../components/product/ProductReviews';
import ProductImageGallery from '../components/product/ProductImageGallery';
import { useProductDwell } from '../hooks/useProductDwell';
import { fetchTimeRecommendations } from '../utils/productTracking';
import { clearRatingsCache } from '../hooks/useProductRatings';

function ProductDetailsPage() {
  const { id } = useParams();

  const [quickViewProduct, setQuickViewProduct] = useState(null);
  useEffect(() => {
    window.scrollTo({
      top: 0,

      behavior: 'smooth'
    });
  }, [id]);

  const navigate = useNavigate();

  const [timeRecommendations, setTimeRecommendations] = useState([]);

  const [recentProducts, setRecentProducts] = useState([]);

  const [coupons, setCoupons] = useState([]);

  const [product, setProduct] = useState(null);

  const [reviews, setReviews] = useState([]);

  const [quantity, setQuantity] = useState(1);

  const [rating, setRating] = useState(5);

  const [comment, setComment] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const productResponse = await axios.get(
          `${API}/products/${id}`
        );

        setProduct(productResponse.data);

        const viewedProducts =
          JSON.parse(localStorage.getItem('recentProducts')) || [];

        const updatedProducts = viewedProducts.filter(
          (item) => item._id !== productResponse.data._id
        );

        updatedProducts.unshift(productResponse.data);

        localStorage.setItem(
          'recentProducts',
          JSON.stringify(updatedProducts.slice(0, 8))
        );

        setRecentProducts(updatedProducts.slice(0, 8));
        const couponResponse = await axios.get(
          `${API}/coupons/active`
        );

        setCoupons(couponResponse.data);

        const reviewResponse = await axios.get(
          `${API}/reviews/product/${id}`
        );

        setReviews(reviewResponse.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [id]);

  /* Track how long this product is on screen (attention-based) */
  useProductDwell(product?._id, 'details', true);

  /*
  Time-based suggestions: re-fetched when the product changes so newly
  accumulated dwell influences what we recommend.
*/
  useEffect(() => {
    const loadRecommendations = async () => {
      const recs = await fetchTimeRecommendations();
      setTimeRecommendations(recs.filter((r) => r._id !== id));
    };

    loadRecommendations();
  }, [id]);

  const addToCart = async () => {
    if (product.stock <= 0) {
      toast.error('Product Out Of Stock');
      return;
    }

    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));

      if (!userInfo) {
        toast.warning('Please Login First');

        navigate('/login');

        return;
      }

      await axios.post(`${API}/cart`, {
        userId: userInfo._id,

        productId: product._id,

        name: product.name,

        image: product.image,

        price: product.price,

        quantity: quantity
      });

      toast.success(`${product.name} added to cart successfully`);
    } catch (error) {
      console.log(error);

      /* Surface the server's reason — trolley full, stock limit — instead of
         a generic failure the shopper can't act on. */
      toast.error(
        error.response?.data?.message || 'Failed to add product to cart'
      );
    }
  };
  const buyNow = () => {
    if (product.stock <= 0) {
      toast.error('Product Out Of Stock');

      return;
    }

    navigate('/checkout', {
      state: {
        buyNowItem: {
          productId: product._id,

          name: product.name,

          quantity: quantity,

          price: product.price,

          /* Carried through so the checkout can show it and, if the shopper
             adds more products, move this line into the cart intact. */
          image: product.image || ''
        }
      }
    });
  };

  const submitReview = async () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));

      if (!userInfo) {
        toast.warning('Please Login First');

        navigate('/login');

        return;
      }

      if (!comment) {
        toast.warning('Please enter review comment');

        return;
      }

      await axios.post(`${API}/reviews`, {
        userId: userInfo._id,

        userName: userInfo.name,

        productId: product._id,

        rating: Number(rating),

        comment: comment
      });

      toast.success('Review Added Successfully');

      /* Listing cards read a cached rating summary — force a refresh */
      clearRatingsCache();

      const { data } = await axios.get(
        `${API}/reviews/product/${product._id}`
      );

      setReviews(data);

      setComment('');

      setRating(5);
    } catch (error) {
      console.log(error);

      toast.error('Failed to add review');
    }
  };
  const deleteReview = async (reviewId) => {
    try {
      await axios.delete(
        `${API}/reviews/delete/${reviewId}`
      );

      toast.success('Review Deleted');

      clearRatingsCache();

      setReviews(reviews.filter((review) => review._id !== reviewId));
    } catch (error) {
      toast.error('Delete Failed');
    }
  };

  if (!product) {
    return (
      <>
        <CustomNavbar />

        <Container className="mt-5">
          <h2 className="text-center">Loading...</h2>
        </Container>
      </>
    );
  }
  /*
    Every product should surface a few highlights. If the product doesn't
    have its own, fall back to a sensible set chosen by category so the
    section is never empty.
  */
  const getHighlights = (prod) => {
    if (prod.highlights && prod.highlights.length > 0) {
      return prod.highlights;
    }

    const byCategory = {
      Electronics: [
        '1 Year Warranty',
        'Latest Technology',
        'Energy Efficient',
        'Premium Build Quality'
      ],
      Fashion: [
        'Premium Fabric',
        'Comfortable Fit',
        'Trendy Design',
        'Easy to Maintain'
      ],
      Mobiles: [
        'High Performance',
        'Long Battery Life',
        'Stunning Display',
        'Fast Charging Support'
      ],
      Home: [
        'Durable Material',
        'Space Saving Design',
        'Easy to Clean',
        'Elegant Finish'
      ],
      Beauty: [
        'Dermatologically Tested',
        'Long Lasting',
        'Suitable for All Skin Types',
        'Cruelty Free'
      ]
    };

    return (
      byCategory[prod.category] || [
        'Top Quality Product',
        'Best Value for Money',
        'Trusted by Customers',
        'Genuine & Brand Verified'
      ]
    );
  };

  const displayHighlights = getHighlights(product);

  const estimatedDelivery = (() => {
    const date = new Date();
    date.setDate(date.getDate() + 5);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  })();

  /* recentProducts is stored most-recent-first, so this order is the actual
     browsing trail once the product being viewed is dropped from it. */
  const recentlyViewed = recentProducts
    .filter((item) => item._id !== product._id)
    .slice(0, 4);

  const averageRating =
    reviews.length > 0
      ? (
          reviews.reduce((sum, review) => sum + review.rating, 0) /
          reviews.length
        ).toFixed(1)
      : 0;

  /* ---- Content blocks (single source, arranged differently per breakpoint) ---- */

  const imageBlock = (
    <ProductImageGallery
      images={product.images}
      image={product.image}
      name={product.name}
    />
  );

  const trustBlock = (
    <Card className="border-0 shadow-sm mt-4 pd-trust-card">
      <Card.Body>
        <Row className="g-3 text-center">
          {[
            { icon: '🚚', title: 'Free Delivery', text: 'On all orders' },
            { icon: '🔄', title: 'Easy Returns', text: '7-day policy' },
            { icon: '🔒', title: 'Secure Payment', text: '100% protected' },
            { icon: '✅', title: 'Genuine Product', text: 'Brand verified' }
          ].map((f, i) => (
            <Col xs={6} key={i}>
              {/* --i staggers the blessing ring so the four icons are
                  consecrated one after another, not all at once */}
              <div className="pd-trust-item" style={{ '--i': i }}>
                <div className="pd-trust-icon">{f.icon}</div>
                <div className="fw-bold small">{f.title}</div>
                <div className="text-muted" style={{ fontSize: '0.78rem' }}>
                  {f.text}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );

  const descBlock = product.description ? (
    <Card className="border-0 shadow-sm mt-4 pd-desc-card">
      <Card.Body>
        <h5 className="fw-bold mb-3">📋 Product Description</h5>
        <p className="text-muted mb-0" style={{ lineHeight: '1.7' }}>
          {product.description}
        </p>
      </Card.Body>
    </Card>
  ) : null;

  const helpBlock = (
    <Card className="border-0 pd-help-card mt-4">
      <Card.Body className="d-flex align-items-center gap-3">
        <div className="pd-help-orb">🙏</div>
        <div>
          <div className="fw-bold">Need help deciding?</div>
          <small className="opacity-75">
            Our support team is here for you 24/7.
          </small>
        </div>
        <Button
          as={Link}
          to="/help"
          variant="light"
          size="sm"
          className="ms-auto rounded-pill fw-semibold"
        >
          Get Help
        </Button>
      </Card.Body>
    </Card>
  );

  const titleBlock = (
    <div className="pd-title-block">
      {product.category && (
        <span className="pd-category-pill">{product.category}</span>
      )}

      <h2 className="fw-bold pd-title">{product.name}</h2>

      <div className="pd-rating-row">
        <span className="pd-rating-chip">⭐ {averageRating}</span>

        <span className="pd-rating-count">
          {reviews.length > 0
            ? `${reviews.length} ${reviews.length === 1 ? 'Rating' : 'Ratings'}`
            : 'Be the first to review'}
        </span>
      </div>
    </div>
  );

  const mrp = Math.round(product.price * 1.2);
  const offPercent = Math.round(((mrp - product.price) / mrp) * 100);
  const savings = mrp - product.price;

  const priceBlock = (
    <div className="pd-price-row mb-3">
      <h1 className="fw-bold mb-0 pd-price">₹{product.price}</h1>

      <span className="pd-mrp">₹{mrp}</span>

      <span className="pd-off-badge">{offPercent}% OFF</span>

      {savings > 0 && (
        <span className="pd-save-pill">You save ₹{savings}</span>
      )}
    </div>
  );

  /* Show only coupons that apply to THIS product: store-wide coupons (no
     product list) or coupons that explicitly include this product. */
  const productCoupons = coupons.filter(
    (coupon) =>
      !coupon.products ||
      coupon.products.length === 0 ||
      coupon.products.map(String).includes(String(product._id))
  );

  const couponBlock = (
    <Card className="border-0 mb-4 pd-offers-card">
      <Card.Body>
        <div className="d-flex align-items-center gap-2 mb-3">
          <span className="pd-offers-icon">🎟</span>
          <h5 className="fw-bold mb-0">Available Offers</h5>
          {productCoupons.length > 0 && (
            <span className="pd-offers-count">{productCoupons.length}</span>
          )}
        </div>

        {productCoupons.length === 0 ? (
          <p className="text-muted mb-0">No active offers for this product</p>
        ) : (
          productCoupons.map((coupon) => (
            <div key={coupon._id} className="pd-ticket">
              {/* Coloured stub, like the admin coupon card */}
              <div className="pd-ticket-stub">
                <span className="pd-ticket-pct">
                  {coupon.discountPercentage}%
                </span>
                <span className="pd-ticket-off">OFF</span>
              </div>

              <div className="pd-ticket-body">
                <div className="pd-ticket-code">{coupon.code}</div>
                <div className="pd-ticket-desc">
                  🏷 Apply at checkout to save
                </div>
              </div>
            </div>
          ))
        )}
      </Card.Body>
    </Card>
  );

  const highlightsBlock = (
    <Card className="border-0 p-3 mb-3 pd-highlights-card">
      <h5 className="fw-bold mt-2">🔥 Product Highlights</h5>

      <div className="d-flex flex-wrap gap-2 mt-3">
        {displayHighlights.map((item, index) => (
          <Badge
            key={index}
            bg="light"
            text="dark"
            className="p-2 pd-highlight"
            style={{ '--i': index }}
          >
            ✓ {item}
          </Badge>
        ))}
      </div>
    </Card>
  );

  const purchaseBlock = (
    <Card
      className="border-0 shadow-lg mt-4 flex-grow-1 pd-purchase-card"
      style={{
        borderRadius: '20px',
        background: 'linear-gradient(135deg,#ffffff,#f8fafc)'
      }}
    >
      <Card.Body className="d-flex flex-column justify-content-center">
        {/* Two lamps flank the stock line rather than floating in the card
            corners, so the row reads as one band: the left lamp shares a
            column with the delivery truck icon below it and the right lamp
            ends flush with the FREE pill. */}
        <div className="pd-stock-row mb-3">
          <span className="pd-diya" aria-hidden="true">
            🪔
          </span>

          {product.stock > 0 ? (
            <span
              className={`pd-stock-badge${product.stock <= 5 ? ' is-low' : ''}`}
            >
              <span className="pd-stock-dot" />
              {product.stock <= 5
                ? `Hurry! Only ${product.stock} left`
                : `In Stock (${product.stock})`}
            </span>
          ) : (
            <span className="pd-stock-badge is-out">✕ Out Of Stock</span>
          )}

          <span className="pd-diya pd-diya-right" aria-hidden="true">
            🪔
          </span>
        </div>

        {product.stock > 0 && (
          <div className="pd-expected-delivery mb-3">
            <span className="pd-delivery-icon">🚚</span>

            <div className="pd-delivery-text">
              <div className="pd-delivery-label">Expected Delivery</div>
              <div className="pd-delivery-date">{estimatedDelivery}</div>
            </div>

            <span className="pd-delivery-free">FREE</span>
          </div>
        )}

        <Row className="g-3 mb-3">
          {/* Quantity card */}
          <Col xs={12} md={6}>
            <Card className="border-0 h-100 pd-qty-card">
              <Card.Body className="d-flex flex-column">
                <div className="d-flex align-items-center justify-content-between mb-3 gap-2">
                  <h6 className="fw-bold mb-0">Quantity</h6>
                  {product.stock > 0 && (
                    <span className="pd-qty-max">Max {product.stock}</span>
                  )}
                </div>

                <div className="pd-qty-stepper">
                  <button
                    type="button"
                    className="pd-qty-btn"
                    aria-label="Decrease quantity"
                    disabled={quantity <= 1}
                    onClick={() => setQuantity(quantity > 1 ? quantity - 1 : 1)}
                  >
                    −
                  </button>

                  <span className="pd-qty-value">{quantity}</span>

                  <button
                    type="button"
                    className="pd-qty-btn"
                    aria-label="Increase quantity"
                    disabled={quantity >= product.stock}
                    onClick={() =>
                      setQuantity(
                        quantity < product.stock ? quantity + 1 : quantity
                      )
                    }
                  >
                    +
                  </button>
                </div>

                <div className="pd-qty-total mt-auto">
                  <div className="pd-qty-total-label">
                    <span>Total Amount</span>
                    <span className="pd-qty-unit">
                      ₹{product.price} × {quantity}
                    </span>
                  </div>

                  <div className="pd-qty-amount" key={quantity}>
                    ₹{(product.price * quantity).toLocaleString()}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Delivery / offers card */}
          <Col xs={12} md={6}>
            <Card
              className="border-0 h-100 pd-delivery-card"
              style={{ borderRadius: '15px' }}
            >
              <Card.Body>
                <h6 className="fw-bold mb-3">Delivery & Offers</h6>

                <div
                  className="d-flex align-items-start gap-2 mb-2 pd-dl-row"
                  style={{ '--i': 0 }}
                >
                  <span>🚚</span>
                  <div>
                    <div className="fw-semibold small">Free Delivery</div>
                    <small className="text-muted">
                      Get it by{' '}
                      <span className="text-success fw-semibold">
                        {estimatedDelivery}
                      </span>
                    </small>
                  </div>
                </div>

                <div
                  className="d-flex align-items-start gap-2 mb-2 pd-dl-row"
                  style={{ '--i': 1 }}
                >
                  <span>💵</span>
                  <div>
                    <div className="fw-semibold small">Cash on Delivery</div>
                    <small className="text-muted">Available on this item</small>
                  </div>
                </div>

                <div
                  className="d-flex align-items-start gap-2 pd-dl-row"
                  style={{ '--i': 2 }}
                >
                  <span>🔄</span>
                  <div>
                    <div className="fw-semibold small">7-Day Replacement</div>
                    <small className="text-muted">Easy & hassle-free</small>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {product.stock > 0 ? (
          <Row className="g-3">
            <Col xs={12} sm={6}>
              <Button
                variant="warning"
                size="lg"
                className="fw-bold shadow w-100 pd-action-btn pd-btn-cart"
                onClick={addToCart}
              >
                <span className="pd-btn-icon">🛒</span> Add To Cart
              </Button>
            </Col>

            <Col xs={12} sm={6}>
              <Button
                variant="danger"
                size="lg"
                className="fw-bold shadow w-100 pd-action-btn pd-btn-buy"
                onClick={buyNow}
              >
                <span className="pd-btn-icon">🔱</span> Buy Now
              </Button>
            </Col>
          </Row>
        ) : (
          <Button variant="secondary" size="lg" className="w-100" disabled>
            Out Of Stock
          </Button>
        )}
      </Card.Body>
    </Card>
  );

  return (
    <>
      <CustomNavbar />

      <div className="pd-wrap">
        <Container>
          {/* Product Details */}

          <Card className="border-0 shadow-lg p-3 p-md-4 pd-main-card">
            <span className="pd-om" aria-hidden="true">
              ॐ
            </span>

            {/* Desktop / tablet: two-column layout */}
            <Row className="d-none d-lg-flex">
              <Col lg={5}>
                {imageBlock}
                {trustBlock}
                {highlightsBlock}
                {helpBlock}
              </Col>

              <Col lg={7} className="d-flex flex-column">
                {titleBlock}
                {priceBlock}
                {couponBlock}
                {descBlock}
                <hr />
                {purchaseBlock}
              </Col>
            </Row>

            {/* Mobile: name → image → highlights → description → price →
                coupon → trust badges → buy/cart, per the requested order */}
            <div className="d-lg-none pd-mobile">
              {titleBlock}
              {imageBlock}
              {highlightsBlock}
              {descBlock}
              {priceBlock}
              {couponBlock}
              {trustBlock}
              {purchaseBlock}
            </div>
          </Card>

          <ProductReviews
            reviews={reviews}
            rating={rating}
            setRating={setRating}
            comment={comment}
            setComment={setComment}
            submitReview={submitReview}
            deleteReview={deleteReview}
          />
          {/* Suggested Products */}

          <ProductMiniGrid
            title="✨ Suggested For You"
            badge="Based on your interest"
            products={timeRecommendations}
            onQuickView={setQuickViewProduct}
          />

          <ProductMiniGrid
            title="👀 Recently Viewed"
            subtitle="Pick up right where you left off"
            badge={`${recentlyViewed.length} ${
              recentlyViewed.length === 1 ? 'item' : 'items'
            }`}
            products={recentlyViewed}
            variant="recent"
            onQuickView={setQuickViewProduct}
          />
        </Container>

        <QuickViewModal
          product={quickViewProduct}
          show={!!quickViewProduct}
          onHide={() => setQuickViewProduct(null)}
        />

        <style>{detailsStyles}</style>
      </div>
    </>
  );
}

const detailsStyles = `
  .pd-wrap {
    background: radial-gradient(720px 320px at 8% -5%, rgba(124,58,237,0.12), transparent 70%), radial-gradient(720px 320px at 92% 105%, rgba(234,88,12,0.14), transparent 70%), linear-gradient(180deg, #faf5ff 0%, #fff7ed 55%, #fef3c7 100%);
    min-height: 100vh;
    padding: clamp(24px, 5vw, 50px) 0;
  }

  .pd-img-card {
    border-radius: 20px;
  }

  /* Trust / services panel */
  .pd-trust-card {
    border-radius: 20px;
  }
  .pd-trust-item {
    padding: 10px 6px;
    border-radius: 14px;
    transition: background 0.2s ease, transform 0.2s ease;
  }
  .pd-trust-item:hover {
    background: #fff7ed;
    transform: translateY(-3px);
  }
  .pd-trust-icon {
    font-size: 1.8rem;
    margin-bottom: 4px;
  }
  .pd-desc-card {
    border-radius: 20px;
  }
  .pd-help-card {
    border-radius: 20px;
    color: #fff;
    background: linear-gradient(120deg, #7c2d12, #ea580c);
  }
  .pd-help-card .btn-light {
    color: #b45309;
  }
  .pd-img-box {
    border-radius: 16px;
    overflow: hidden;
  }
  .pd-main-img {
    width: 100%;
    height: clamp(280px, 38vw, 420px);
    object-fit: contain;
    transition: transform 0.4s ease;
  }
  .pd-img-box:hover .pd-main-img {
    transform: scale(1.06);
  }

  .pd-title {
    line-height: 1.3;
    font-size: clamp(1.5rem, 4vw, 2.1rem);
  }
  .pd-price {
    font-size: clamp(1.9rem, 5vw, 2.6rem);
  }
  .pd-off-badge {
    font-size: 0.8rem;
    border-radius: 30px;
    padding: 6px 12px;
  }

  /* Section header */
  .pd-section-card {
    border-radius: 25px;
  }
  .pd-section-bar {
    display: inline-block;
    width: 6px;
    height: 26px;
    border-radius: 6px;
    background: linear-gradient(180deg, #ea580c, #f59e0b);
  }
  .pd-section-count {
    border-radius: 30px;
    padding: 7px 14px;
    border: 1px solid #e5e7eb;
  }

  /* Recommended / Recently viewed mini cards */
  .pd-mini-card {
    border-radius: 20px;
    overflow: hidden;
    background: #fff;
    border: 2px solid transparent !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  }
  .pd-mini-card:hover {
    transform: translateY(-8px);
    border-color: rgba(234, 88, 12, 0.35) !important;
    box-shadow: 0 22px 40px rgba(194, 65, 12, 0.22) !important;
  }
  .pd-mini-img-wrap {
    position: relative;
    overflow: hidden;
  }
  .pd-mini-img {
    width: 100%;
    height: clamp(150px, 20vw, 210px);
    object-fit: cover;
    transition: transform 0.45s ease;
  }
  .pd-mini-card:hover .pd-mini-img {
    transform: scale(1.08);
  }
  .pd-mini-badge {
    position: absolute;
    top: 10px; left: 10px;
    z-index: 2;
    border-radius: 30px;
    padding: 5px 10px;
    font-size: 0.72rem;
  }
  .pd-mini-overlay {
    position: absolute;
    inset: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
    background: linear-gradient(to top, rgba(17,24,39,0.5), rgba(17,24,39,0));
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  .pd-mini-card:hover .pd-mini-overlay {
    opacity: 1;
  }
  .pd-mini-overlay-btn {
    background: rgba(255,255,255,0.95);
    color: #111827;
    font-weight: 700;
    font-size: 0.8rem;
    padding: 8px 16px;
    border-radius: 50px;
    transform: translateY(10px);
    transition: transform 0.3s ease;
  }
  .pd-mini-card:hover .pd-mini-overlay-btn {
    transform: translateY(0);
  }
  .pd-mini-stars {
    font-size: 0.75rem;
    letter-spacing: 1px;
  }
  .pd-mini-name {
    font-size: 0.95rem;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .pd-mini-btn {
    border-radius: 12px;
    font-weight: bold;
    transition: transform 0.25s ease;
  }
  .pd-mini-btn:hover {
    transform: translateY(-2px);
  }

  /* Coupons */
  /* Highlights */
  .pd-highlight {
    border-radius: 30px !important;
    border: 1px solid #fde68a !important;
    background: #fff7ed !important;
    color: #9a3412 !important;
    font-weight: 600;
    transition: transform 0.2s ease, background 0.2s ease;
  }
  .pd-highlight:hover {
    transform: translateY(-2px);
    background: #fef3c7 !important;
  }

  /* Action buttons */
  .pd-action-btn {
    border-radius: 14px;
    padding: 12px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .pd-action-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 28px rgba(0,0,0,0.18) !important;
  }

  /* Review form */
  .pd-review-form-card {
    border-radius: 25px;
    overflow: hidden;
  }
  .pd-review-form-header {
    background: linear-gradient(135deg, #7c2d12, #ea580c);
    padding: 22px 30px;
    color: #fff;
  }
  .pd-star-picker {
    display: flex;
    gap: 6px;
  }
  .pd-star {
    background: none;
    border: none;
    font-size: 2rem;
    line-height: 1;
    color: #d1d5db;
    cursor: pointer;
    padding: 0;
    transition: transform 0.15s ease, color 0.15s ease;
  }
  .pd-star:hover {
    transform: scale(1.2);
  }
  .pd-star-on {
    color: #f59e0b;
  }
  .pd-rating-label {
    border-radius: 30px;
    padding: 6px 14px;
    font-size: 0.8rem;
  }
  .pd-review-textarea {
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    padding: 14px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
  .pd-review-textarea:focus {
    border-color: #ea580c;
    box-shadow: 0 0 0 0.2rem rgba(234, 88, 12, 0.15);
  }
  .pd-review-submit {
    border-radius: 50px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .pd-review-submit:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 28px rgba(245, 158, 11, 0.45);
  }

  /* Review cards */
  .pd-review-card {
    border-radius: 15px;
    background: #f8fafc;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .pd-review-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 26px rgba(0,0,0,0.08) !important;
  }
  .pd-review-avatar {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #ea580c, #f59e0b);
  }

  @media (max-width: 991.98px) {
    .pd-img-card { position: static; }
  }

  /* Mobile single-column order: name → image → description → highlights →
     price → coupon → trust → buy/cart. Uniform spacing via a flex column;
     each block's own margins/flex-grow are neutralised so nothing doubles. */
  .pd-mobile {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .pd-mobile > * {
    margin: 0 !important;
    flex: 0 0 auto !important;
  }
  .pd-mobile .pd-title-block { margin-bottom: 0; }
  .pd-mobile .pd-title { font-size: 1.4rem; margin-bottom: 6px; }
  .pd-mobile .pd-price { font-size: 2rem; }

  /* ===================== Premium polish ===================== */

  /* Main product card — warm gradient, gold top trim, soft entrance */
  .pd-main-card {
    border-radius: 30px !important;
    position: relative;
    overflow: hidden;
    background:
      radial-gradient(700px 240px at 100% 0%, rgba(245,158,11,0.10), transparent 70%),
      linear-gradient(160deg, #ffffff 0%, #fffaf3 60%, #fff7ed 100%) !important;
    box-shadow: 0 30px 70px rgba(124,45,18,0.14) !important;
    animation: pdFadeUp 0.5s ease both;
  }
  .pd-main-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 5px;
    background: linear-gradient(90deg, #7c2d12, #ea580c 45%, #f59e0b);
  }
  @keyframes pdFadeUp {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* Gallery */
  .pd-img-card {
    border-radius: 22px;
    background: linear-gradient(160deg, #ffffff, #fff7ed) !important;
    box-shadow: 0 12px 34px rgba(124,45,18,0.10) !important;
  }
  .pd-img-box {
    border-radius: 18px;
    background: linear-gradient(160deg, #fdf7ee, #f8fafc);
  }

  /* Title + price */
  .pd-title { color: #3b0764; letter-spacing: -0.4px; }
  .pd-price {
    font-weight: 800;
    background: linear-gradient(90deg, #c2410c, #ea580c);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  /* Category eyebrow */
  .pd-category-pill {
    display: inline-block;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #b45309;
    background: #fff7ed;
    border: 1px solid #fde68a;
    padding: 4px 12px;
    border-radius: 20px;
    margin-bottom: 10px;
  }

  /* Rating row */
  .pd-rating-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 6px;
  }
  .pd-rating-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.82rem;
    font-weight: 800;
    color: #7c2d12;
    background: linear-gradient(135deg, #fde68a, #fbbf24);
    padding: 5px 12px;
    border-radius: 20px;
    box-shadow: 0 4px 10px rgba(245,158,11,0.3);
  }
  .pd-rating-count {
    color: #9ca3af;
    font-size: 0.88rem;
    font-weight: 600;
  }

  /* Price row */
  .pd-price-row {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px;
  }
  .pd-mrp {
    color: #9ca3af;
    text-decoration: line-through;
    font-size: 1.05rem;
    font-weight: 600;
  }
  .pd-off-badge {
    display: inline-block;
    color: #fff;
    font-size: 0.8rem;
    font-weight: 800;
    border-radius: 30px;
    padding: 6px 14px;
    background: linear-gradient(135deg, #16a34a, #15803d);
    box-shadow: 0 6px 16px rgba(22,163,74,0.35);
  }
  .pd-save-pill {
    font-size: 0.78rem;
    font-weight: 800;
    color: #b45309;
    background: #fff7ed;
    border: 1px dashed #f59e0b;
    padding: 5px 12px;
    border-radius: 20px;
  }

  /* Offers card */
  .pd-offers-card {
    border-radius: 20px !important;
    background: linear-gradient(160deg, #ffffff, #fffaf3) !important;
    border: 1px solid #f1e4d0 !important;
    box-shadow: 0 10px 28px rgba(124,45,18,0.07) !important;
  }
  .pd-offers-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px; height: 36px;
    flex-shrink: 0;
    border-radius: 10px;
    font-size: 1.05rem;
    background: linear-gradient(135deg, #fde68a, #fbbf24);
    box-shadow: 0 4px 10px rgba(245,158,11,0.3);
  }
  .pd-offers-count {
    margin-left: auto;
    font-size: 0.72rem;
    font-weight: 800;
    color: #b45309;
    background: #fff7ed;
    border: 1px solid #fde68a;
    padding: 3px 10px;
    border-radius: 20px;
  }

  /* Ticket-style coupon — matches the admin coupon card: coloured stub with
     the %OFF, a perforated edge, and a white body carrying the code. */
  .pd-ticket {
    position: relative;
    display: flex;
    align-items: stretch;
    margin-bottom: 10px;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 6px 16px rgba(124, 45, 18, 0.10);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
  }
  .pd-ticket:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 34px rgba(234, 88, 12, 0.22);
  }
  /* The warm "BURN" stub */
  .pd-ticket-stub {
    position: relative;
    flex-shrink: 0;
    width: 84px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: linear-gradient(135deg, #dc2626, #ea580c 55%, #f59e0b);
    background-size: 160% 160%;
    animation: pdTicketBurn 5s ease-in-out infinite;
  }
  @keyframes pdTicketBurn {
    0%, 100% { background-position: 0% 50%; }
    50%      { background-position: 100% 50%; }
  }
  /* perforated tear between stub and body */
  .pd-ticket-stub::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 0; bottom: 0;
    width: 16px;
    background-image: radial-gradient(circle at center, #fff 5px, transparent 6px);
    background-size: 16px 17px;
    background-repeat: repeat-y;
    background-position: center;
  }
  .pd-ticket-pct {
    font-size: 1.55rem;
    font-weight: 800;
    line-height: 1;
    text-shadow: 0 2px 6px rgba(0,0,0,0.2);
  }
  .pd-ticket-off {
    font-size: 0.64rem;
    font-weight: 800;
    letter-spacing: 1.5px;
    margin-top: 2px;
  }
  .pd-ticket-body {
    flex: 1 1 auto;
    min-width: 0;
    padding: 14px 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .pd-ticket-code {
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: 1.5px;
    color: #7c2d12;
    /* dashed underline reads as a coupon code you can copy */
    border-bottom: 2px dashed #fdba74;
    display: inline-block;
    padding-bottom: 2px;
    align-self: flex-start;
  }
  .pd-ticket-desc {
    font-size: 0.78rem;
    color: #a16207;
    font-weight: 600;
    margin-top: 6px;
  }

  /* Description — gold accent rail */
  .pd-desc-card {
    border-radius: 20px;
    border-left: 5px solid #f59e0b !important;
    background: linear-gradient(160deg, #ffffff, #fffaf3) !important;
  }

  /* Trust panel — icons in gold bubbles */
  .pd-trust-card {
    background: linear-gradient(160deg, #ffffff, #fffaf3) !important;
  }
  .pd-trust-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px; height: 48px;
    margin: 0 auto 8px;
    border-radius: 50%;
    background: linear-gradient(135deg, #fff7ed, #fde68a);
    box-shadow: 0 6px 14px rgba(245,158,11,0.25);
  }
  .pd-trust-item:hover { background: #fffaf0; }

  /* Highlights — gold pills */
  .pd-highlights-card {
    border-radius: 18px !important;
    background: linear-gradient(160deg, #ffffff, #fff7ed) !important;
    box-shadow: 0 10px 26px rgba(124,45,18,0.07);
  }
  .pd-highlight {
    background: #ffffff !important;
    border: 1px solid #fde68a;
    color: #b45309 !important;
    border-radius: 30px !important;
    font-weight: 700;
    padding: 8px 14px !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }
  .pd-highlight:hover {
    transform: translateY(-2px);
    background: linear-gradient(135deg, #fde68a, #fbbf24) !important;
    box-shadow: 0 8px 18px rgba(245,158,11,0.3);
  }

  /* Purchase panel */
  .pd-purchase-card {
    border-radius: 22px !important;
    background: linear-gradient(160deg, #ffffff, #fffaf3) !important;
    box-shadow: 0 20px 46px rgba(124,45,18,0.12) !important;
  }
  /* Stock line: lamp | badge | lamp.
     The 14px side padding matches the delivery strip's 5px accent border +
     9px padding, and .pd-diya matches .pd-delivery-icon's 44px width — so the
     lamp column, the badge's left edge and the strip's icon + label columns
     all share the same two vertical guides. */
  .pd-stock-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 14px;
  }

  /* Stock badge — live pulsing dot + low-stock urgency state.
     In-stock is the deep temple saffron; low stock stays a brighter, hotter
     amber so the two states still read apart at a glance. */
  .pd-stock-badge {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    min-width: 0;
    border-radius: 30px;
    padding: 9px 18px;
    font-size: 0.85rem;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #d97706, #92400e);
    box-shadow: 0 6px 16px rgba(217,119,6,0.32);
  }
  .pd-stock-badge.is-low {
    background: linear-gradient(135deg, #fbbf24, #ea580c);
    box-shadow: 0 6px 16px rgba(234,88,12,0.34);
  }
  .pd-stock-badge.is-out {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    box-shadow: 0 6px 16px rgba(220,38,38,0.32);
  }
  .pd-stock-dot {
    width: 8px;
    height: 8px;
    flex-shrink: 0;
    border-radius: 50%;
    background: #fff;
    animation: pdStockPulse 1.8s ease-in-out infinite;
  }
  @keyframes pdStockPulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(255,255,255,0.75); opacity: 1; }
    50%      { box-shadow: 0 0 0 7px rgba(255,255,255,0); opacity: 0.7; }
  }

  /* Expected delivery strip.
     The 5px accent bar is a border, so it eats into the box on the left only —
     the left padding is dropped by the same 5px to keep the icon optically the
     same distance from the edge as the FREE pill is from the right. */
  .pd-expected-delivery {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    border: 1px solid #fde68a;
    border-left: 5px solid #ea580c;
    background: linear-gradient(100deg, #fff7ed, #ffffff 70%);
    border-radius: 14px;
    padding: 12px 14px 12px 9px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .pd-expected-delivery:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(234,88,12,0.16);
  }
  .pd-delivery-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 50%;
    font-size: 1.25rem;
    background: linear-gradient(135deg, #fef3c7, #fde68a);
    box-shadow: 0 4px 12px rgba(217,119,6,0.22);
  }
  /* Explicit line-heights on both lines: without them the label inherits the
     body's 1.5 and the pair sits a few pixels low against the 44px icon. */
  .pd-delivery-text {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .pd-delivery-label {
    font-size: 0.72rem;
    font-weight: 700;
    color: #a16207;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    line-height: 1.2;
    margin-bottom: 2px;
  }
  .pd-delivery-date {
    font-size: clamp(1rem, 3.5vw, 1.15rem);
    font-weight: 800;
    color: #9a3412;
    line-height: 1.2;
  }
  .pd-delivery-free {
    margin-left: auto;
    flex-shrink: 0;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.6px;
    color: #9a3412;
    background: #fef3c7;
    border: 1px solid #fcd34d;
    padding: 5px 12px;
    border-radius: 20px;
  }
  @media (max-width: 400px) {
    .pd-delivery-free { margin-left: 0; }
  }
  @media (prefers-reduced-motion: reduce) {
    .pd-stock-dot { animation: none; }
  }
  .pd-delivery-card {
    background: linear-gradient(160deg, #fffaf3, #fff7ed) !important;
    border: 1px solid #fde68a !important;
  }
  .pd-action-btn {
    border: none;
    border-radius: 14px !important;
    font-weight: 800;
    padding: 13px 16px;
    transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;
  }
  .pd-action-btn:hover {
    transform: translateY(-3px);
    filter: brightness(1.06);
    box-shadow: 0 16px 30px rgba(0,0,0,0.18);
  }

  /* ---- Quantity card ---- */
  .pd-qty-card {
    border-radius: 18px !important;
    background: linear-gradient(160deg, #ffffff, #f8fafc) !important;
    border: 1px solid #eef2f7 !important;
  }
  .pd-qty-max {
    font-size: 0.7rem;
    font-weight: 700;
    color: #b45309;
    background: #fff7ed;
    border: 1px solid #fde68a;
    padding: 3px 10px;
    border-radius: 20px;
    white-space: nowrap;
  }

  /* Segmented stepper pill */
  .pd-qty-stepper {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: clamp(6px, 2vw, 14px);
    padding: 6px;
    border-radius: 50px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);
    max-width: 100%;
  }
  .pd-qty-btn {
    width: clamp(38px, 10vw, 46px);
    height: clamp(38px, 10vw, 46px);
    flex-shrink: 0;
    border: none;
    border-radius: 50%;
    font-size: 1.35rem;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    background: linear-gradient(135deg, #3b0764, #7c2d12);
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
  }
  .pd-qty-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    filter: brightness(1.18);
    box-shadow: 0 8px 18px rgba(124,45,18,0.35);
  }
  .pd-qty-btn:active:not(:disabled) { transform: scale(0.94); }
  .pd-qty-btn:disabled {
    background: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
    box-shadow: none;
  }
  .pd-qty-value {
    min-width: 42px;
    text-align: center;
    font-size: clamp(1.2rem, 4vw, 1.5rem);
    font-weight: 800;
    color: #1f2937;
  }

  /* Total amount */
  .pd-qty-total {
    margin-top: 18px;
    padding-top: 14px;
    border-top: 1px dashed #e5e7eb;
  }
  .pd-qty-total-label {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 6px;
    font-size: 0.78rem;
    font-weight: 600;
    color: #9ca3af;
  }
  .pd-qty-unit { color: #94a3b8; }
  .pd-qty-amount {
    font-size: clamp(1.7rem, 6vw, 2.2rem);
    font-weight: 800;
    line-height: 1.15;
    background: linear-gradient(90deg, #16a34a, #0d9488);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: pdAmountPop 0.28s ease;
  }
  @keyframes pdAmountPop {
    from { transform: scale(0.92); opacity: 0.45; }
    to   { transform: scale(1); opacity: 1; }
  }
  @media (prefers-reduced-motion: reduce) {
    .pd-qty-amount { animation: none; }
  }

  /* Help banner */
  .pd-help-card {
    transition: transform 0.25s ease, box-shadow 0.25s ease;
  }
  .pd-help-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 36px rgba(194,65,12,0.3) !important;
  }

  @media (prefers-reduced-motion: reduce) {
    .pd-main-card { animation: none; }
  }

  /* =====================================================================
     Divine motion — one distinct ritual per card so no two cards on this
     page move the same way.
     ===================================================================== */

  /* ---- Main sheet: aarti halo circling behind + ॐ breathing + live trim -- */
  .pd-main-card > .row,
  .pd-main-card > .pd-mobile {
    position: relative;
    z-index: 1;
  }
  .pd-main-card::before {
    background: linear-gradient(90deg, #7c2d12, #ea580c 28%, #fbbf24 50%, #ea580c 72%, #7c2d12);
    background-size: 200% 100%;
    animation: pdTrim 6s linear infinite;
    z-index: 3;
  }
  @keyframes pdTrim {
    from { background-position: 0% 0; }
    to   { background-position: 200% 0; }
  }
  .pd-om {
    position: absolute;
    z-index: 0;
    top: 6px;
    right: 22px;
    font-size: clamp(80px, 12vw, 150px);
    line-height: 1;
    pointer-events: none;
    color: rgba(180, 83, 9, 0.07);
    animation: pdOmBreath 7s ease-in-out infinite;
  }
  @keyframes pdOmBreath {
    0%, 100% { opacity: 0.55; transform: scale(1); }
    50%      { opacity: 1;    transform: scale(1.06); }
  }

  /* ---- Price: molten gold flowing through the figure, savings pill glows -- */
  .pd-price {
    background: linear-gradient(90deg, #c2410c, #ea580c 25%, #f59e0b 50%, #ea580c 75%, #c2410c);
    background-size: 250% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    animation: pdPriceFlow 5s linear infinite;
  }
  @keyframes pdPriceFlow {
    from { background-position: 0% 0; }
    to   { background-position: 250% 0; }
  }
  .pd-save-pill {
    animation: pdSaveGlow 3s ease-in-out infinite;
  }
  @keyframes pdSaveGlow {
    0%, 100% { box-shadow: 0 0 0 0 rgba(245,158,11,0.45); border-color: #f59e0b; }
    50%      { box-shadow: 0 0 0 6px rgba(245,158,11,0);   border-color: #fbbf24; }
  }

  /* ---- Trust panel: a blessing ring circles each icon in turn ---- */
  .pd-trust-icon {
    position: relative;
  }
  .pd-trust-icon::after {
    content: '';
    position: absolute;
    inset: -5px;
    border-radius: 50%;
    background: conic-gradient(from 0deg, transparent 0 60%, rgba(245,158,11,0.95) 76%, rgba(253,230,138,0) 90%);
    -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
    mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
    opacity: 0;
    animation: pdBless 6s linear infinite;
    animation-delay: calc(var(--i, 0) * 1.5s);
  }
  @keyframes pdBless {
    0%        { opacity: 0; transform: rotate(0deg); }
    5%        { opacity: 1; }
    28%       { opacity: 1; transform: rotate(360deg); }
    36%, 100% { opacity: 0; transform: rotate(360deg); }
  }

  /* ---- Description: the gold rail burns downward like a wick ---- */
  .pd-desc-card {
    position: relative;
    overflow: hidden;
    border-left: 0 !important;
  }
  .pd-desc-card::before {
    content: '';
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 5px;
    background: linear-gradient(180deg, #fde68a, #f59e0b 22%, #ea580c 50%, #f59e0b 78%, #fde68a);
    background-size: 100% 220%;
    animation: pdWick 4.5s linear infinite;
  }
  @keyframes pdWick {
    from { background-position: 0 0; }
    to   { background-position: 0 -220%; }
  }

  /* ---- Help banner: prayer rings pulsing out of the 🙏 orb ---- */
  .pd-help-card {
    position: relative;
    overflow: hidden;
    background-size: 200% 200%;
    animation: pdHelpDrift 10s ease-in-out infinite;
  }
  @keyframes pdHelpDrift {
    0%, 100% { background-position: 0% 50%; }
    50%      { background-position: 100% 50%; }
  }
  .pd-help-orb {
    position: relative;
    flex-shrink: 0;
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    border-radius: 50%;
    background: rgba(255, 247, 237, 0.18);
  }
  .pd-help-orb::before,
  .pd-help-orb::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid rgba(253, 230, 138, 0.8);
    animation: pdPrayerRing 3.2s ease-out infinite;
  }
  .pd-help-orb::after { animation-delay: -1.6s; }
  @keyframes pdPrayerRing {
    0%   { transform: scale(0.75); opacity: 0.85; }
    100% { transform: scale(1.75); opacity: 0; }
  }

  /* ---- Offers: a flower garland runs along the top of the card ---- */
  .pd-offers-card {
    position: relative;
    overflow: hidden;
  }
  .pd-offers-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 7px;
    background-image:
      radial-gradient(circle at 6px 3.5px, rgba(245,158,11,0.95) 2.6px, transparent 3.2px),
      radial-gradient(circle at 18px 3.5px, rgba(220,38,38,0.75) 2.1px, transparent 2.7px);
    background-size: 24px 7px;
    animation: pdGarland 3s linear infinite;
  }
  @keyframes pdGarland {
    from { background-position: 0 0, 0 0; }
    to   { background-position: 24px 0, 24px 0; }
  }
  /* the ticket icon sways like a temple bell */
  .pd-offers-icon {
    transform-origin: 50% 0%;
    animation: pdBellSway 3.4s ease-in-out infinite;
  }
  @keyframes pdBellSway {
    0%, 100% { transform: rotate(-11deg); }
    50%      { transform: rotate(11deg); }
  }

  /* ---- Highlights: camphor light passes over each pill in turn ---- */
  .pd-highlight {
    position: relative;
    overflow: hidden;
  }
  .pd-highlight::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(105deg, transparent 35%, rgba(251,191,36,0.6) 50%, transparent 65%);
    transform: translateX(-130%);
    animation: pdCamphor 5s ease-in-out infinite;
    animation-delay: calc(var(--i, 0) * 0.45s);
  }
  @keyframes pdCamphor {
    0%        { transform: translateX(-130%); }
    40%, 100% { transform: translateX(130%); }
  }

  /* ---- Purchase panel: two lamps lit at the threshold + rising aura ---- */
  .pd-purchase-card {
    position: relative;
    overflow: hidden;
  }
  .pd-purchase-card > .card-body {
    position: relative;
    z-index: 1;
  }
  .pd-purchase-card::after {
    content: '';
    position: absolute;
    z-index: 0;
    left: 50%;
    bottom: -120px;
    width: 340px;
    height: 240px;
    transform: translateX(-50%);
    pointer-events: none;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(251,191,36,0.28), transparent 68%);
    animation: pdAura 6.5s ease-in-out infinite;
  }
  @keyframes pdAura {
    0%, 100% { opacity: 0.45; transform: translateX(-50%) scale(0.9); }
    50%      { opacity: 1;    transform: translateX(-50%) scale(1.12); }
  }
  /* Width matches .pd-delivery-icon so the lamp sits dead-centre over the
     truck icon on the row below; the flicker scales the glyph without
     disturbing the row because the column width is fixed. */
  .pd-diya {
    width: 44px;
    flex-shrink: 0;
    text-align: center;
    font-size: 1.35rem;
    line-height: 1;
    pointer-events: none;
    animation: pdFlicker 2.4s ease-in-out infinite;
  }
  .pd-diya-right { margin-left: auto; animation-delay: -1.1s; }
  @media (max-width: 420px) {
    .pd-stock-row { padding: 0 4px; gap: 6px; }
    .pd-diya { width: 30px; font-size: 1.15rem; }
  }
  @keyframes pdFlicker {
    0%, 100% { transform: scale(1) rotate(-3deg);    filter: drop-shadow(0 0 5px rgba(245,158,11,0.5)); }
    50%      { transform: scale(1.14) rotate(3deg);  filter: drop-shadow(0 0 14px rgba(251,191,36,0.95)); }
  }

  /* ---- Quantity card: a mandala turning slowly behind the stepper ---- */
  .pd-qty-card {
    position: relative;
    overflow: hidden;
  }
  .pd-qty-card > .card-body {
    position: relative;
    z-index: 1;
  }
  /* Total reads as temple gold rather than ledger green */
  .pd-qty-amount {
    background: linear-gradient(90deg, #7c2d12, #b45309 22%, #f59e0b 50%, #b45309 78%, #7c2d12);
    background-size: 250% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: pdAmountPop 0.28s ease, pdAmountGold 7s linear infinite;
  }
  @keyframes pdAmountGold {
    from { background-position: 0% 0; }
    to   { background-position: 250% 0; }
  }

  /* A sheet of warm light descends through the card, like an aarti plate
     lowered over an offering — vertical, so it reads apart from the
     horizontal camphor sweep on the highlight pills. */
  .pd-qty-card::after {
    content: '';
    position: absolute;
    z-index: 0;
    left: 0; right: 0;
    height: 45%;
    pointer-events: none;
    background: linear-gradient(180deg, transparent, rgba(251,191,36,0.30) 45%, rgba(253,230,138,0.16) 60%, transparent);
    transform: translateY(-130%);
    animation: pdAarti 6.5s ease-in-out infinite;
  }
  @keyframes pdAarti {
    0%        { transform: translateY(-130%); }
    55%, 100% { transform: translateY(240%); }
  }
  /* The divider above the total becomes a running gold thread */
  .pd-qty-total {
    position: relative;
    border-top: 0 !important;
  }
  .pd-qty-total::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 2px;
    background-image: repeating-linear-gradient(90deg, rgba(245,158,11,0.85) 0 8px, transparent 8px 16px);
    background-size: 16px 2px;
    animation: pdThread 2.4s linear infinite;
  }
  @keyframes pdThread {
    from { background-position: 0 0; }
    to   { background-position: 16px 0; }
  }

  /* ---- Action buttons: gold offering plate vs. burning vermilion ---- */
  .pd-action-btn {
    position: relative;
    overflow: hidden;
    letter-spacing: 0.3px;
  }
  .pd-btn-icon {
    display: inline-block;
    margin-right: 6px;
  }

  /* Add To Cart — beaten gold, with a shine crossing it every 4.5s */
  .pd-btn-cart {
    color: #431407 !important;
    background: linear-gradient(120deg, #fde68a, #fbbf24 30%, #f59e0b 55%, #fbbf24 75%, #fde68a) !important;
    background-size: 220% 220% !important;
    box-shadow: 0 10px 24px rgba(245, 158, 11, 0.42) !important;
    animation: pdGoldPan 8s ease-in-out infinite;
  }
  @keyframes pdGoldPan {
    0%, 100% { background-position: 0% 50%; }
    50%      { background-position: 100% 50%; }
  }
  .pd-btn-cart::after {
    content: '';
    position: absolute;
    inset: -50%;
    pointer-events: none;
    background: linear-gradient(112deg, transparent 44%, rgba(255,255,255,0.75) 50%, transparent 56%);
    transform: translateX(-90%);
    animation: pdBtnShine 4.5s ease-in-out infinite;
  }
  @keyframes pdBtnShine {
    0%        { transform: translateX(-90%); }
    42%, 100% { transform: translateX(90%); }
  }
  .pd-btn-cart .pd-btn-icon {
    animation: pdCartNudge 3.6s ease-in-out infinite;
  }
  @keyframes pdCartNudge {
    0%, 62%, 100% { transform: translateX(0); }
    70%           { transform: translateX(4px) rotate(-6deg); }
    80%           { transform: translateX(-2px) rotate(3deg); }
  }

  /* Buy Now — vermilion embers breathing under the surface */
  .pd-btn-buy {
    color: #fff7ed !important;
    background: linear-gradient(120deg, #7f1d1d, #b91c1c 35%, #dc2626 60%, #ea580c) !important;
    background-size: 200% 200% !important;
    animation: pdEmberPan 6s ease-in-out infinite, pdEmberGlow 2.8s ease-in-out infinite;
  }
  @keyframes pdEmberPan {
    0%, 100% { background-position: 0% 50%; }
    50%      { background-position: 100% 50%; }
  }
  @keyframes pdEmberGlow {
    0%, 100% { box-shadow: 0 10px 24px rgba(185, 28, 28, 0.38); }
    50%      { box-shadow: 0 10px 30px rgba(234, 88, 12, 0.62); }
  }
  .pd-btn-buy .pd-btn-icon {
    animation: pdTrishul 2.8s ease-in-out infinite;
  }
  @keyframes pdTrishul {
    0%, 100% { transform: scale(1);    filter: drop-shadow(0 0 3px rgba(253,230,138,0.5)); }
    50%      { transform: scale(1.16); filter: drop-shadow(0 0 11px rgba(253,230,138,1)); }
  }

  /* ---- Delivery & offers: each promise is lit in turn ---- */
  .pd-delivery-card {
    background-size: 180% 180%;
    animation: pdDeliveryDrift 12s ease-in-out infinite;
  }
  @keyframes pdDeliveryDrift {
    0%, 100% { background-position: 0% 0%; }
    50%      { background-position: 100% 100%; }
  }
  .pd-dl-row > span:first-child {
    display: inline-block;
    animation: pdLit 4.5s ease-in-out infinite;
    animation-delay: calc(var(--i, 0) * 1.5s);
  }
  @keyframes pdLit {
    0%, 26%, 100% { transform: scale(1);    filter: none; }
    10%           { transform: scale(1.3);  filter: drop-shadow(0 0 9px rgba(245,158,11,0.95)); }
  }

  @media (prefers-reduced-motion: reduce) {
    .pd-main-card::before,
    .pd-price,
    .pd-save-pill,
    .pd-om,
    .pd-trust-icon::after,
    .pd-desc-card::before,
    .pd-help-card,
    .pd-help-orb::before,
    .pd-help-orb::after,
    .pd-offers-card::before,
    .pd-offers-icon,
    .pd-highlight::after,
    .pd-purchase-card::after,
    .pd-diya,
    .pd-qty-amount,
    .pd-qty-card::after,
    .pd-qty-total::before,
    .pd-delivery-card,
    .pd-dl-row > span:first-child,
    .pd-btn-cart,
    .pd-btn-cart::after,
    .pd-btn-cart .pd-btn-icon,
    .pd-btn-buy,
    .pd-btn-buy .pd-btn-icon {
      animation: none;
    }
    .pd-btn-cart::after { opacity: 0; }
    .pd-trust-icon::after,
    .pd-help-orb::before,
    .pd-help-orb::after,
    .pd-highlight::after { opacity: 0; }
  }
`;

export default ProductDetailsPage;
